import { ButtonProps, Button, useColorModeValue } from "@chakra-ui/react";

export default function BccOrCCButton({ children, ...rest }: ButtonProps) {
  const color = useColorModeValue("cdsGrey.900", "var(--chakra-colors-whiteAlpha-900)");
  return (
    <Button
      variant="unstyled"
      borderRadius="5px"
      borderColor="tableUnderlineBorder.DEFAULT"
      borderWidth="1px"
      color={color}
      width="31px"
      height="29px"
      fontSize="12px"
      lineHeight="14.4px"
      p="0"
      mx="1"
      minW="unset"
      sx={{ boxSizing: "content-box" }}
      {...rest}
    >
      {children}
    </Button>
  );
}
